var map = {
	"./airtel-logo.png": 1207,
	"./airtel-logo@2x.png": 1208,
	"./banners/benefits1.png": 1209,
	"./banners/benefits2.png": 1210,
	"./banners/cards1.png": 1211,
	"./banners/cards2.png": 1212,
	"./banners/hero/typeA1.png": 1213,
	"./banners/hero/typeA2.png": 1214,
	"./banners/hero/typeA3.png": 1215,
	"./banners/hero/typeA4.png": 1216,
	"./banners/hero/typeB1.png": 1217,
	"./banners/hero/typeB2.png": 1218,
	"./banners/hero/typeC.png": 1219,
	"./banners/hero/typeD.png": 1220,
	"./banners/hero/typeE.png": 1221,
	"./banners/hub1.png": 1222,
	"./banners/others/advantages.png": 1223,
	"./banners/others/articles1.png": 1224,
	"./banners/others/articles2.png": 1225,
	"./banners/others/carousel1.png": 1226,
	"./banners/others/carousel2.png": 1227,
	"./banners/others/media1.png": 1228,
	"./banners/others/media2.png": 1229,
	"./banners/others/news.png": 1230,
	"./banners/others/testimonials.png": 1231,
	"./banners/skinnyLanding1.png": 1232,
	"./banners/skinnyLanding2.png": 1233,
	"./banners/skinnySelfcare1.png": 1234,
	"./banners/supportLanding.png": 1235,
	"./buttons-usage.png": 890,
	"./footers/default.png": 1236,
	"./footers/productLanding.png": 1237,
	"./footers/standardLanding.png": 1238,
	"./grids-behaviour/1024px.png": 359,
	"./grids-behaviour/1366px.png": 360,
	"./grids-behaviour/1600px.png": 361,
	"./grids-behaviour/1920px.png": 362,
	"./grids-behaviour/320px.png": 363,
	"./grids-behaviour/768px.png": 364,
	"./grids/landing_maincontainer+margin.png": 347,
	"./grids/landing_verticalsectionmarker+maincontainer.png": 348,
	"./grids/selfcare_left+main+rightcontainer.png": 349,
	"./grids/selfcare_left+maincontainer.png": 350,
	"./grids/selfcare_main+rightcontainer.png": 351,
	"./grids/selfcare_sidenav+2level+maincontainer.png": 352,
	"./grids/selfcare_sidenav+maincontainer.png": 353,
	"./grids/selfcare_steptracker+left+main+rightcontainer.png": 354,
	"./grids/selfcare_steptracker+left+maincontainer.png": 355,
	"./grids/selfcare_steptracker+main+rightcontainer.png": 356,
	"./grids/selfcare_steptracker+maincontainer.png": 357,
	"./grids/selfcare_steptracker+map+maincontainer.png": 358,
	"./headers/landingPage.png": 1239,
	"./headers/standardDefault.png": 1240,
	"./headers/standardOnlyActionIcons.png": 1241,
	"./headers/standardWithoutBillable.png": 1242,
	"./headers/standardWithoutLink.png": 1243,
	"./headers/statusPage.png": 1244,
	"./home-layers.png": 545,
	"./home-layers@2x.png": 546,
	"./hotspots/landing/typeAVersion1.png": 1245,
	"./hotspots/landing/typeAVersion2.png": 1246,
	"./hotspots/landing/typeAVersion3.png": 1247,
	"./hotspots/landing/typeBVersion1.png": 1248,
	"./hotspots/landing/typeBVersion2.png": 1249,
	"./hotspots/landing/typeCVersion1.png": 1250,
	"./hotspots/landing/typeCVersion2.png": 1251,
	"./hotspots/landing/typeD.png": 1252,
	"./hotspots/selfcare/typeA.png": 1253,
	"./hotspots/selfcare/typeBVersion1.png": 1254,
	"./hotspots/selfcare/typeBVersion2.png": 1255,
	"./maps/cluster-and-legend.png": 1256,
	"./maps/order-lines.png": 1257,
	"./maps/pin.png": 1258,
	"./maps/pop-and-legend.png": 1259,
	"./notifications/action-notification.png": 1260,
	"./notifications/inline-notification.png": 1261,
	"./tags/draggable-tags.png": 446,
	"./tags/tags-cloud.png": 447
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1206;


//////////////////
// WEBPACK FOOTER
// ./src/assets/images ^\.\/.*$
// module id = 1206
// module chunks = 0